import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[inputAlphanumeric]',
    standalone: false
})
export class InputAlphanumericDirective {
  regexStr      = '^[A-Za-z0-9]*$';
  regexOnlyChar = '^[A-Za-z0-9]*$';

  constructor(private readonly el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (this.el.nativeElement.value === '') {
      return new RegExp(this.regexOnlyChar).test(event.key);
    } else {
      return new RegExp(this.regexStr).test(event.key);
    }
  }

  @HostListener('paste', ['$event']) blockPaste() {
    this.validateFields();
  }

  private validateFields() {
    this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^A-Za-z0-9À-ÖØ-öø-ÿ]+/g, '').trimEnd();
  }

}
